import type { ReactNode } from 'react';
import styles from './DialogFooter.module.css';

export const DialogFooter = ({ children }: { children: ReactNode }) => (
  <div className={styles.footer}>{children}</div>
);
